/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [index.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 25.09.18 19:35
 */

import { combineReducers } from 'redux';
import PostsReducer from './reducers/posts-reducer';
import CommentsReducer from './reducers/comments-reducer';
import FriendsReducer, {FriendChatReducer, FriendsPending} from './reducers/friends-reducer';
import FollowersReducer from './reducers/followers-reducer';
import FolloweesReducer from './reducers/followees-reducer';
import LikesReducer, {CommentLikesReducer} from './reducers/likes-reducer';
import AuthorizationReducer, {ConfigurationReducer, LocalConfigReducer} from './reducers/authorization-reducer';
import CreateUserReducer from './reducers/create-user-reducer';
import LoginDataReducer from './reducers/logindata-reducer';
import SpacesReducer, {EventsReducer, ShopsReducer, MembersReducer,
    MediaReducer} from './reducers/spaces-reducer';
import {HomeDataReducer, GenericDataReducer} from './reducers/genericdata-reducer';
import ChatEntriesReducer, {ChatCountReducer, IncomingChatReducer} from './reducers/chat-reducer';
import WidgetReducer, {PageReducer} from './reducers/widget-reducer';
import ErrorReducer from "./reducers/error-reducer";
import {SearchReducer} from "./reducers/search-reducer";
import {MemberReducer, UserdataReducer} from "./reducers/member-reducer";
import {PublicEventsReducer, PublicSpacesReducer, ViewEventsReducer, ViewSpacesReducer} from "./reducers/fetch-public-spaces";
import NotificationReducer from "./reducers/notification-reducer";
import GalleriesNotificationReducer from "./reducers/galleries-reducer";

const rootReducer = combineReducers({
    configuration: ConfigurationReducer,
    localconfig: LocalConfigReducer,
    authorization: AuthorizationReducer,
    logindata: LoginDataReducer,            // returns more information about the authorized user

    /** POSTS (comments, likes) **/
    posts: PostsReducer,
    comments: CommentsReducer,
    likes: LikesReducer,
    commentLikes: CommentLikesReducer,

    /** FRIENDS/ CHAT */
    friends: FriendsReducer,                // list of all friends for logged in user
    pending: FriendsPending,                // list of pending requests for friendship
    friend: FriendChatReducer,              // current open friend on chat
    chatEntries: ChatEntriesReducer,        // list of chat entries for current open chat
    chatCount: ChatCountReducer,            // count of delivered chat entries
    incomingChat: IncomingChatReducer,      // last delivered chat entry (may be null)

    /** SPACE MEMBERS */
    members: MembersReducer,                // list of members for current space
    member: MemberReducer,                  // current open member on panel

    /** FOLLOWERS (@deprecated) **/
    followers: FollowersReducer,            // no longer supported - ?? need to purge
    followees: FolloweesReducer,            // no longer supported - ?? need to purge

    /** SPACE DATA **/
    homedata: HomeDataReducer,              // space data about the currently loaded home space
    genericdata: GenericDataReducer,        // space data about the currently loaded generic space
    userdata: UserdataReducer,              // ?? this looks like duplicated data in homedata.userdata ?? need to purge

    /** OWNER SPACES **/
    spaces: SpacesReducer,                  // authorized user specific spaces (own or joined)
    events: EventsReducer,                  // authorized specific events (own or joined)
    shops: ShopsReducer,                    // authorized user specific shops (own or joined)

    /** 3D PARTY USER SPACES **/
    viewSpaces: ViewSpacesReducer,          // spaces specific to a user (not authorized user)
    viewEvents: ViewEventsReducer,          // events specific to a user (not authorized user)

    /** PUBLIC SPACES **/
    publicSpaces: PublicSpacesReducer,      // spaces from public user
    publicEvents: PublicEventsReducer,      // events from public user

    /** NOTIFICATIONS
     * intended for hooks and reflects status of last axios final call as in
     * notification = {
     *      page: {action: 'fetch', status: 'success', payload: page},
     *      page: {action: 'fetch', status: 'error', payload: error},
     *      space: {action: 'delete', status: 'success', payload: space},
     * }
     * **/
    notifications: NotificationReducer,      // kind of generic notifications for internal use
    galleries: GalleriesNotificationReducer,
    media: MediaReducer,
    request: CreateUserReducer,
    search: SearchReducer,
    widgets: WidgetReducer,
    page: PageReducer,
    error: ErrorReducer,
});

export default rootReducer;